'client-only';

import { useCallback, useContext } from 'react';

import { ProductsContext } from '../contexts/productsContext';

export const useProducts = () => {
  const context = useContext(ProductsContext);

  if (!context) {
    throw new Error('useProducts must be used within a ProductsProvider');
  }

  const getProductById = useCallback(
    (id: string) => {
      return context.products.find((product) => product.id === id);
    },
    [context.products],
  );

  const getProductVariantById = useCallback(
    (id: string) => {
      return context.products
        .flatMap((product) => product.variants.nodes)
        .find((variant) => variant.id === id);
    },
    [context.products],
  );

  return {
    products: context.products,
    getProductById,
    getProductVariantById,
  };
};
